import React from "react";
import { PremiumContentSubListItemTemplate } from "themes/application/payment/components";

function PremiumContentSubListItem(props) {
    return <PremiumContentSubListItemTemplate {...props} />;
}

export default PremiumContentSubListItem;
